// src/config/features.js
// Marka bazlı geçit konabilen ana modüller. key = route path (baştaki "/" olmadan).
// Dashboard, Setup, Brands, Users geçit dışıdır (rol ile korunur, her zaman görünür).
export const GATEABLE_FEATURES = [
  { key: 'smartbot', label: 'SmartBot' },
  { key: 'quiz', label: 'Smart Quiz' },
  { key: 'smart-cart', label: 'Smart Cart' },
  { key: 'smart-search', label: 'Smart Search' },
  { key: 'smart-cip', label: 'Smart CIP' },
  { key: 'smart-library', label: 'Smart Library' },
  { key: 'smart-blog', label: 'Smart Blog' },
  { key: 'smart-mailing', label: 'Smart Mailing' },
  { key: 'smart-event', label: 'Smart Event' },
  { key: 'smart-target', label: 'Smart Target' },
  { key: 'smart-view', label: 'Smart View' },
  { key: 'smart-review', label: 'Smart Review' },
  { key: 'smart-content', label: 'Smart Content' },
  { key: 'smart-geo', label: 'Smart GEO' },
  { key: 'smart-sgo', label: 'Smart SGO' },
  { key: 'smart-showcase', label: 'Smart Showcase' },
  { key: 'smart-video', label: 'Smart Video' },
  { key: 'smart-ranking', label: 'Smart Ranking' },
  { key: 'smart-analysis', label: 'Smart Analysis' },
  { key: 'segments', label: 'Smart Recommendation' },
  { key: 'influencers', label: 'Influencers' },
  { key: 'influencer-dashboard', label: 'Inf. Dashboard' },
  { key: 'products', label: 'Products' },
]

export const GATEABLE_KEYS = GATEABLE_FEATURES.map(f => f.key)

export function pathToKey(path) {
  return path === '/' ? 'dashboard' : path.replace(/^\//, '')
}

// Kurallar:
// - super_admin her şeyi görür
// - geçit konmayan modüller (dashboard/setup/brands/users) her zaman açık
// - enabled_features null/array değilse => hepsi açık (geriye uyumlu)
// - aksi halde sadece listedeki anahtarlar açık
export function canAccessFeature(account, key) {
  if (!account) return true
  if (account.role === 'super_admin') return true
  if (!GATEABLE_KEYS.includes(key)) return true
  const ef = account.enabled_features
  if (!Array.isArray(ef)) return true
  return ef.includes(key)
}
